import { OrgId } from 'app/common/types/id'
import { getOrgs } from 'app/dataProviders/org'
import { Params } from 'app/dataTypes/org'

let orgsAbortController: AbortController | undefined
export const getFilterOrgs = async (params: Params = {}) => {
  orgsAbortController?.abort()
  orgsAbortController = new AbortController()
  const orgs = await getOrgs(params, orgsAbortController?.signal)
  if (orgs) {
    const items = Array.from(orgs.items).map(([_, { ID: id, title }]) => ({
      id: id as OrgId,
      title,
    }))
    return items
  }
  return []
}
